import dayjs from 'dayjs';
/**
 * calculates difference in minutes between time (hourse and minutes) represented in strings
 * @param time_from time in 'HH:mm' format (08:30)
 * @param time_to time in 'HH:mm' format (20:30)
 * @returns difference in minutes
 */
export function differenceBetweenTime(time_from: string, time_to: string): number {
  if (!time_from || !time_to) {
    return 0;
  }
  const hoursStart = parseInt(time_from.split(':')[0], 10);
  const minutesStart = parseInt(time_from.split(':')[1], 10);
  const hoursEnd = parseInt(time_to.split(':')[0], 10);
  const minutesEnd = parseInt(time_to.split(':')[1], 10);
  const time_start_int = (hoursStart * 60) + (minutesStart);
  let time_end_int = (hoursEnd * 60) + (minutesEnd);
  const minutesInADay = 24 * 60;
  time_end_int += minutesInADay;
  let difference = time_end_int - time_start_int;
  if (difference > minutesInADay) {
    difference -= minutesInADay;
  }
  return difference;
}

/**
 * builds string from minutes in format 'HH:mm'
 * @param minutes
 * @returns string in 'HH:mm' format
 */
export function minutesToTimeString(minutes: number): string {
  let hoursString = ((minutes - (minutes % 60)) / 60).toString();
  if (hoursString.length === 1) {
    hoursString = `0${hoursString}`;
  }
  let minutesString = (minutes % 60).toString();
  if (minutesString.length === 1) {
    minutesString = `0${minutesString}`;
  }
  const time = `${hoursString}:${minutesString}`;
  return time;
}

/**
 * Returns the name of the month
 * @param numberMonth
 * @returns string
 */
export function getMonthName(numberMonth: number): string {
  const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
  return months[numberMonth - 1] || '';
}

export function formatDateForHumanSpecies(date: string): string {
  try {
    return dayjs(date).format('YYYY-MM-DD');
  } catch (e) {
    console.error(e);
    return date;
  }
}

export function formatDateTimeForHumanSpecies(timestamp: number): string {
  try {
    return dayjs.unix(timestamp).format('YYYY-MM-DD HH:mm:ss');
  } catch (e) {
    console.error(e);
    return timestamp.toString();
  }
}
